<template lang="pug">
    .hero.is-danger.is-bold.is-medium
        .hero-body
            .container
                .title NOT FOUND
</template>

<script>
export default {
  name: "Page404"
};
</script>

<style scoped></style>
